











































































































































































































































































































import dayjs from "@/plugins/dayjs";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { AbnormalGoodsOrderAPI } from "@/common/api/userManage/idolSaleMachineAbnormalGoodsOrderList";

import { excuteDownloadExport2Excel } from "@/common/xlsx";


// import { util } from "vue/types/umd";
import { DeepLoop } from "@/common/deepLoop/deepLoop";

import {
  idolSaleMachineType2Ch,
  idolSaleMachineAbnormalStatus2Ch,
  idolAbnormalGOResStatusType2Ch,
  getCommonList,
  shareConfirmOptions,
  shareShopType2ch
} from '@/common/config'


// 暴露的API 列表
export const pageApiList = getPageAPIs(AbnormalGoodsOrderAPI);

console.log(pageApiList, 'pageApiList')

// 1待处理 2已处理
const handleStatus2Ch: string[] = ['', '待处理', '已处理']






const defaultForm = {
  handle_type: 1,

  activity_id: '', // 活动ID
  shop_name: '', // 店铺名称
  device_id: '', // 设备号
  phone: '', // 用户手机号
  device_type: -1, // 设备类型
  excepts: '', // 异常类型
  status: '', // 处理结果
  opt_uid: '', // 操作人id

  time: [
    
  ], // 日期
}


@Component({
  filters: {
    showAbnormalOrderTypeName(excepts: number[]) {
      if (!Array.isArray(excepts)) return ''
      return excepts.map((except: number) => idolSaleMachineAbnormalStatus2Ch[except]).join(';')
    },

    showResStatusName(status: number) {
      return idolAbnormalGOResStatusType2Ch[status]
    }

    
  },
  components: {

  },
})
export default class IdolAbnormalGoodsOrderList extends Vue {
  private form: any = {
    // couponId: "",
    // time: [],
    // startDate: "",
    // endDate: "",
  };
  // private forms: any = {
  //   // maxType: "0",
  //   // ...defaultForms
  // };

  private deepLoopUtil: any = {};

  // private timeRangeModes: any[] = [
  //   ...(defaultChooseRangeModes || [])
  // ]

  // private curRangeMode: string = defaultChooseRangeModeName

  private handleStatusList: any[] = [
    ...getCommonList(handleStatus2Ch, 1)
  ]

  private machineTypeList: any[] = [
    ...getCommonList(idolSaleMachineType2Ch, 1)
  ]

  private orderAbnormalStatusList: any[] = [
    ...getCommonList(idolSaleMachineAbnormalStatus2Ch, 1)
  ].filter((item: any) => !!item.label)

  private resStatusTypeList: any[] = [
    ...getCommonList(idolAbnormalGOResStatusType2Ch, 1)
  ]


  private abnormalGoodsOrderApi = new AbnormalGoodsOrderAPI();
  // private couponTimeDurationAPI = new CouponTimeDurationManageAPI();
  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
      
    };

    // this.forms = {
    //   ...this.deepLoopUtil.deepCopy(defaultForms, false),
    // };

    // this.searchVenuePageOption = {
    //   ...this.deepLoopUtil.deepCopy(defaultSearchVenuePageOption, false),
    // };

    // this.merchantApi = new MerchantApi();
  }

  private created(): void {
    console.log(this.$route)
  }

  private activated() {
    this.refrshTableDataList();
  }

  private mount():void {
    this.refrshTableDataList();
  }
  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };
    // this.form = new Util().clearObject(this.form);
    // this.$router.replace("/orderList");
    this.refrshTableDataList();
  }

  // 跳转 异常订单详情
  private onGoAbnormalGoodsDetail(abnormalGoodsOrderItem: any) {
    this.$router.push({
      path: '/idolAbnormalGoodsOrderDetail',
      query: {
        goods_order_id: abnormalGoodsOrderItem.id
      }
    })
  }

  //搜索
  private search(): void {
    this.tablePage.page = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.refrshTableDataList();
  }

  private tableData: any[] = [];

  //dialog
  // private dialogFormVisible: boolean = false;
  private formLabelWidth: string = "100px";
  // private options: any = [];

  // private clearObject(): void {
  //   this.dialogFormVisible = false;
  //   this.forms = new Util().clearObject(this.forms);
  // }
  // private tablePage: any = {
  //   count: 0,
  //   page: 1,
  //   prepage: 10,
  //   pageSizes: [10, 20, 50, 100, 200, 500],
  //   totalPage: 0,
  // };
  // //翻页
  // private handlePageChange(val: any) {
  //   this.tablePage.page = val.currentPage;
  //   this.tablePage.prepage = val.pageSize;
  //   this.refrshTableDataList();
  // }
  
 

  // private handleChangeTimeRange(range: any) {
  //   console.log(range, 'range')
  //   this.curRangeMode = range.name

  //   const chooseTimeRanges = range.rangeFunc()

  //   this.$set(this.form, 'time', chooseTimeRanges)
  // }

  private tablePage: any = {
    count: 0,
    page: 1,
    prepage: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
    totalPage: 0,
  };
  // //翻页
  private handlePageChange(val: any) {
    console.log(val, 'val')
    this.tablePage.page = val.currentPage;
    this.tablePage.prepage = val.pageSize;
    this.refrshTableDataList();
  }


  private refrshTableDataList() {
    const params = this.getAbnormalGoodsOrderParams()

    if (typeof params != 'object') return

    this.abnormalGoodsOrderApi.getAbnormalGoodsOrderRecordTableList(
      {
        ...params
      },
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        // totalCount: 0,
        // page: 1,
        // pageSize: 10,
        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "page", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

      },
      () => {

      }
    )

  }

  private getAbnormalGoodsOrderParams(mode = "all"): any {
    const params: any = {};

    const form = this.form;

    const tablePage = this.tablePage;

    const {
      handle_type,
      activity_id,
      shop_name,
      device_id,
      phone,
      device_type,
      excepts,
      status,
      opt_uid,
      time 
    } = form;


    if (activity_id) {
      params.activity_id = activity_id
    }

    if (shop_name) {
      params.shop_name = shop_name
    }

    if (device_id) {
      params.device_id = device_id
    }


    if (phone) {
      params.phone = phone;
    }

    if (device_type > -1) {
      params.device_type = device_type
    }

    if (excepts) {
      params.excepts = excepts
    }

    if (status) {
      params.status = status
    }

    if (opt_uid) {
      params.opt_uid = opt_uid
    }

    

    Object.assign(params, {
      handle_type
    })

    const { page, prepage: pageSize } = tablePage || {};

   if (Array.isArray(time) && time.length === 2) {
      const [startDate, endDate] = time;

      const startTime = Util.dateTimeUtilnohms(startDate);
      const endTime = Util.dateTimeUtilnohms(endDate);

      params.open_start_date = startTime;

      params.open_end_date = endTime;
    }


    if (
      mode == "exportExcel" &&
      !(params.open_start_date && params.open_end_date)
    ) {
      this.$message.error("请选择时段导出数据");
      return null;
    }

    if (mode === "all") {
      params.page = page;

      params.limit = pageSize;

    }

    console.log(params, "params");

  
    return params;
  }

   // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    const { 

    } = data;
    const newData = {
      ...data,
   
    };

    return newData;
  }

  /** 导出excel */
  private downloadExcelLoading: boolean = false;

  // 用户字段名 文案对应关系
  private userExcelList2ch: any = {
    activity_id: "活动ID",
    shop_name: "店铺名称",
    device_id: "设备号",
    _excepts_list: "异常类型",
    user_name: "用户昵称",
    open_time: "开门时间",
    opt_name: "操作人",
    handle_time: "处理时间",
    _status_name: "处理结果",
    _result_goods: "处理前",
    _order_goods: "处理后"
  };
  // 用户Excel 表头的先后顺序
  private userExcelSortList: string[] = [
    "activity_id",
    "shop_name",
    "device_id",
    "_excepts_list",
    "user_name",
    "open_time",
    "opt_name",
    "handle_time",
    "_status_name",
    "_result_goods",
    "_order_goods"
  ];

  // 点击导出excel 表格
  private handleDownloadExcel() {
    const params = this.getAbnormalGoodsOrderParams("exportExcel");

    if (params === null) {
      return false;
    }

    this.downloadExcelLoading = true;
    this.abnormalGoodsOrderApi.exportExcelAbnormalGoodsOrderTableList(
      params,
      (res: any) => {
        const { open_start_date: start_date, open_end_date: end_date } = params || {};

        const filename = `商品异常订单列表 ${start_date}到${end_date}.xlsx`;
        const { data } = res || {};

        const { list: originList } = data || {};

        const newList = Array.isArray(originList)
          ? originList.map((item) => {
              const {
                excepts,
                status,
                result_goods = [],
                order_goods = [],
              } = item;
              const newItem = {
                ...(item || {}),
                _excepts_list: excepts.map((except: number) => idolSaleMachineAbnormalStatus2Ch[except]).join(';'),

                _status_name: idolAbnormalGOResStatusType2Ch[status],

                _result_goods: result_goods.map((goodItm: any, index: number) => {
                  return `${index + 1}、${goodItm.product_name}x${ goodItm.product_num } ¥${ goodItm.price }`
                }).join('\n'),

                _order_goods: order_goods.map((goodItm: any, index: number) => {
                  return `${index + 1}、${goodItm.product_name}x${ goodItm.product_num } ¥${ goodItm.price }`
                }).join('\n'),
              
              };


              return newItem;
            })
          : [];

        if (newList.length > 0) {
          const userExcelSortList = this.userExcelSortList;

          const userExcelList2ch = this.userExcelList2ch;

          const excelJSONData = getExcelJSONDataByList(
            newList,
            userExcelSortList,
            userExcelList2ch
          );

          excuteDownloadExport2Excel(excelJSONData, filename);
        } else {
          this.$message.info("选中时段没有可导出的信息");
        }

        this.downloadExcelLoading = false;
      },
      () => {
        this.downloadExcelLoading = false;
      }
    );
  }

  /** end 导出excel */

}
